import { useSelector } from 'react-redux';
import { UserType } from 'shared/enums/UserType';
import { selectUserState } from 'shared/redux/slicers/user.slicer';

const useUser = () => {
  const { user } = useSelector(selectUserState);
  const userTypes = user?.attributes.user_types;
  const isUserTypeGuardian = userTypes?.indexOf(UserType.GUARDIAN) !== -1;
  const isUserTypeTalent = userTypes?.indexOf(UserType.TALENT) !== -1;
  return {
    isUserTypeGuardian,
    isUserTypeTalent,
  };
};

export { useUser };
